var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87906 21C3.7052 21 3.53525 20.9485 3.39068 20.8519C3.24612 20.7554 3.13345 20.6181 3.06691 20.4575C3.00038 20.2968 2.98297 20.1201 3.0169 19.9496C3.05082 19.7791 3.13456 19.6225 3.2575 19.4995L19.4994 3.25746C19.6643 3.09261 19.8879 3 20.121 3C20.3541 3 20.5777 3.09261 20.7425 3.25746C20.9074 3.42231 21 3.64589 21 3.87902C21 4.11215 20.9074 4.33573 20.7425 4.50057L4.50061 20.7427C4.41906 20.8244 4.32217 20.8892 4.21551 20.9333C4.10884 20.9775 3.9945 21.0002 3.87906 21Z",
    fill: "#A93E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1209 21C20.0055 21.0002 19.8912 20.9775 19.7845 20.9333C19.6778 20.8892 19.5809 20.8244 19.4994 20.7427L3.25746 4.50057C3.09261 4.33573 3 4.11215 3 3.87902C3 3.64589 3.09261 3.42231 3.25746 3.25746C3.4223 3.09261 3.64588 3 3.87901 3C4.11214 3 4.33572 3.09261 4.50056 3.25746L20.7425 19.4995C20.8654 19.6225 20.9492 19.7791 20.9831 19.9496C21.017 20.1201 20.9996 20.2968 20.9331 20.4575C20.8666 20.6181 20.7539 20.7554 20.6093 20.8519C20.4648 20.9485 20.2948 21 20.1209 21Z",
    fill: "#A93E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkCrossIcon);
export default __webpack_public_path__ + "static/media/pinkCrossIcon.d0d988b7152d225a5d6099f9dc5ed207.svg";
export { ForwardRef as ReactComponent };